var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.134 23H9.23v-9.347h2.903V23zM10.68 12.378C9.753 12.378 9 11.609 9 10.68a1.68 1.68 0 0 1 3.362 0c0 .928-.753 1.697-1.681 1.697zM22.997 23H20.1v-4.55c0-1.085-.022-2.475-1.51-2.475-1.508 0-1.74 1.178-1.74 2.397V23h-2.9v-9.347h2.785v1.275h.04c.388-.735 1.334-1.51 2.746-1.51 2.938 0 3.478 1.935 3.478 4.447V23h-.003z",
    fillRule: "nonzero"
  })));
};
export default SvgLinkedin;